'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

require('./_item-preview.scss');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Close = require('../../shared/icons/Close');

var _Close2 = _interopRequireDefault(_Close);

var _Uniform = require('../../Uniform');

var _propTypes = require('../../../shared/prop-types');

var _hudlG11n = require('hudl-g11n');

var _hudlG11n2 = _interopRequireDefault(_hudlG11n);

var _i18nKeys = require('../../../shared/i18n-keys');

var _i18nKeys2 = _interopRequireDefault(_i18nKeys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FormattedMessage = _hudlG11n2.default.ReactIntl.FormattedMessage;

var NEXT_ITEM_VISIBLE_THRESHOLD_MS = 10000;

var ItemPreview = function (_Component) {
  _inherits(ItemPreview, _Component);

  function ItemPreview(props) {
    _classCallCheck(this, ItemPreview);

    var _this = _possibleConstructorReturn(this, (ItemPreview.__proto__ || Object.getPrototypeOf(ItemPreview)).call(this, props));

    _this.toggleAutoAdvance = function () {
      var _this$props = _this.props,
          player = _this$props.player,
          setAutoAdvance = _this$props.setAutoAdvance;

      setAutoAdvance(player.playerId, !player.autoAdvance);
    };

    _this.close = function () {
      // Forcibly hide the preview
      _this.setState({
        closed: true,
        didClose: true
      });
    };

    _this.playPreviewItem = function () {
      var _this$props2 = _this.props,
          previous = _this$props2.previous,
          player = _this$props2.player;

      var newIndex = player.playingIndex + (previous ? -1 : 1);
      _this.props.setPlayingIndex(player.playerId, newIndex);
    };

    _this.unhide = function () {
      if (_this.state.closed) {
        _this.setState({ closed: false });
      }

      if (_this.props.onShow) {
        var isPrevious = !!_this.props.previous;
        _this.props.onShow(isPrevious);
      }
    };

    _this.state = {
      closed: false,
      didClose: false,
      inCountdownWindow: false,
      isEndOfVideo: false
    };
    return _this;
  }

  _createClass(ItemPreview, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var player = this.props.player;
      var timeRemaining = player.durationMs - nextProps.currentTimeMs;
      var inCountdownWindow = !isNaN(timeRemaining) && player.durationMs > 0 && timeRemaining <= NEXT_ITEM_VISIBLE_THRESHOLD_MS;

      if (player.playingIndex !== nextProps.player.playingIndex) {
        this.setState({ closed: false });

        if (this.props.setAutoAdvance && player.playerId) {
          this.props.setAutoAdvance(player.playerId, true);
        }
      }

      var didClose = this.state.didClose && inCountdownWindow;
      this.setState({
        didClose: didClose,
        inCountdownWindow: inCountdownWindow
      });

      if (this.props.next && this.props.onShow) {
        var showingCountdown = !this.state.didClose && inCountdownWindow && player.autoAdvance;
        if (showingCountdown && !this.state.inCountdownWindow) {
          var isPrevious = false;
          this.props.onShow(isPrevious);
        }
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return this.props.previous !== nextProps.previous || this.props.next !== nextProps.next || this.props.player.autoAdvance !== nextProps.player.autoAdvance || this.props.hide !== nextProps.hide || this.state !== nextState;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          next = _props.next,
          player = _props.player,
          previous = _props.previous;


      var item = previous || next;
      if (!item || !item.thumbnail) {
        return _react2.default.createElement(
          'div',
          { className: 'item-preview' },
          this.props.children
        );
      }

      var thumbnailStyle = {
        backgroundImage: 'url(' + item.thumbnail + ')'
      };

      var _state = this.state,
          didClose = _state.didClose,
          inCountdownWindow = _state.inCountdownWindow;

      var showPreview = !didClose && inCountdownWindow && next && player.autoAdvance;

      var classes = (0, _classnames2.default)({
        'item-preview': true,
        'item-preview--hidden': this.props.hide || this.state.closed,
        'item-preview--visible': showPreview
      });

      return _react2.default.createElement(
        'div',
        { className: classes, onMouseOver: this.unhide },
        _react2.default.createElement(
          'div',
          { className: 'item-preview__content' },
          _react2.default.createElement('div', { className: 'item-preview__thumbnail', style: thumbnailStyle,
            onClick: this.playPreviewItem }),
          _react2.default.createElement(
            'div',
            { className: 'item-preview__description' },
            _react2.default.createElement(
              'div',
              { className: 'item-preview__label' },
              previous ? _react2.default.createElement(FormattedMessage, {
                id: _i18nKeys2.default.viewPrevious,
                defaultMessage: 'Previous'
              }) : _react2.default.createElement(FormattedMessage, {
                id: _i18nKeys2.default.viewNext,
                defaultMessage: 'Up next'
              })
            ),
            _react2.default.createElement(
              'div',
              { className: 'item-preview__title', onClick: this.playPreviewItem },
              _react2.default.createElement(
                _Uniform.Link,
                { type: 'implied' },
                item.title
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'item-preview__author' },
              item.ownerName
            ),
            next && _react2.default.createElement(
              'div',
              { className: 'item-preview__cancel', onClick: this.toggleAutoAdvance },
              _react2.default.createElement(
                _Uniform.Link,
                { type: 'implied' },
                _react2.default.createElement(FormattedMessage, {
                  id: player.autoAdvance ? _i18nKeys2.default.autoplayOff : _i18nKeys2.default.autoplayOn,
                  defaultMessage: player.autoAdvance ? 'Turn Autoplay Off' : 'Turn Autoplay On'
                })
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'item-preview__close', onClick: this.close },
              _react2.default.createElement(_Close2.default, null)
            )
          )
        ),
        this.props.children
      );
    }
  }]);

  return ItemPreview;
}(_react.Component);

ItemPreview.propTypes = {
  children: _react.PropTypes.element,
  currentTimeMs: _react.PropTypes.number,
  hide: _react.PropTypes.bool,
  next: _propTypes.PlayablePreview,
  onShow: _react.PropTypes.func,
  previous: _propTypes.PlayablePreview,
  player: _react.PropTypes.object.isRequired,
  setAutoAdvance: _react.PropTypes.func,
  setPlayingIndex: _react.PropTypes.func.isRequired
};
exports.default = ItemPreview;